var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "59.6195mm",
    height: "59.6195mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2876 2876",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str0 {stroke:black;stroke-width:85.0853}\r\n    .fil0 {fill:none}\r\n    .fil1 {fill:#E23C19}\r\n    .fil2 {fill:#FD8800}\r\n    .fil4 {fill:#FEFEFE}\r\n    .fil3 {fill:#FFE016}\r\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 2876,
    height: 2876
  }), /*#__PURE__*/React.createElement("g", {
    id: "_595100528"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M846 1418c-108,-60 -174,-139 -178,-279 -196,164 -189,516 -134,657 -33,13 -78,-21 -100,-54 -166,704 416,954 946,836 613,24 1057,53 946,-837 -20,11 -56,32 -76,39 13,-195 -56,-390 -127,-547 -58,87 -96,79 -192,135 51,-326 39,-672 -701,-1098 99,495 -488,500 -384,1148z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1389 2545c598,-8 901,-516 609,-1024 -49,106 -181,139 -221,140 -38,-153 179,-615 -538,-853 81,472 -349,402 -325,875 -83,-44 -129,-122 -151,-210 -325,531 30,1102 626,1072z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1415 2544c437,21 663,-537 421,-773 -24,66 -28,140 -107,151 30,-330 -287,-296 -229,-632 -516,186 -446,496 -420,607 -57,21 -147,-8 -157,-103 -223,423 76,748 492,750z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M1415 2544c213,-10 347,-233 240,-464 -22,37 -47,52 -81,71 -31,-127 40,-241 -234,-370 28,204 -138,178 -129,384 -40,-8 -53,-52 -59,-91 -128,174 -29,484 263,470z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M771 912c27,-186 179,-319 10,-498 -34,158 -239,308 -10,498z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M2015 705c-31,-185 92,-276 -64,-414 -74,162 -199,245 7,375l57 39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M2397 1445c118,-63 80,-285 -13,-355 -18,85 -66,137 -71,182 -9,76 66,112 84,173z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.9b8a5d8e2ae506b6a736608ff5b91f0a.svg";
export { ForwardRef as ReactComponent };